import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import themeStyles from './StaticNumberChart.styles';
import StaticNumberChartUi from './StaticNumberChartUi';
const StaticNumberChart = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { chartItemTitle, chartItemValue, chartItemBodyText } = fields;
    const GraphicContainer = themeStyles.apply('div', 'GraphicContainer');
    return (_jsx(GraphicContainer, { children: _jsx(StaticNumberChartUi, { chartValue: `${chartItemValue === null || chartItemValue === void 0 ? void 0 : chartItemValue.value}+`, chartTitle: chartItemTitle === null || chartItemTitle === void 0 ? void 0 : chartItemTitle.value, chartBodyText: chartItemBodyText === null || chartItemBodyText === void 0 ? void 0 : chartItemBodyText.value }) }));
};
export default StaticNumberChart;
